import React from 'react'
import PlanCard from '../PlanCard'

type Props = {
  price: string
  url: string
}

export const PaymentSignature = (props: Props) => {
  const { price, url } = props
  return (
    <>
      <div>
        <div className="flex flex-wrap items-center justify-center py-4 pt-0">
          <PlanCard
            title="Assinatura"
            price={price}
            cents={price}
            // caption="Faça uma assinatura"
            description={['Ganhe 7 dias gratuitos']}
            benefits={['pagamento recorrente', 'Sem preocupações']}
            cardColor="#3EB9F2"
            buttonText={
              <div className=" w-full h-full ">
                <div className="flex flex-col items-center justify-center w-full h-full">
                  <a
                    style={{ color: '#3EB9F2' }}
                    className="w-4/6 py-2 mt-2 font-semibold text-center bg-white rounded"
                    href={url}
                  >
                    Faça sua assinatura
                  </a>
                </div>
              </div>
            }
          />
        </div>
      </div>
    </>
  )
}
